import { useEffect, useState } from "react";
import { Oval } from "react-loader-spinner";
import axios from "../../../../services/axios-config";
import styles from "./css/registerDialog.module.css";
import { GrPowerReset } from "react-icons/gr";
import { IoIosCloseCircle } from "react-icons/io";
import BoxAlert from "../../../../components/boxAlert/index.jsx";




export default function RegisterDialog ({view, onClose, onReturn, lead}) {

    // VARIÁVEIS DE EDIÇÃO ===============================>

    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [phone, setPhone] = useState(null);
    const [document, setDocument] = useState(null);
    
    const [checkActive , setCheckActive] = useState(false);
    const [checkIsValid , setCheckIsValid] = useState(false);
    
    const options = [
      {value: 0, label: 'Instagram'},
      {value: 1, label: 'Facebook'},
      {value: 2, label: 'Whatsapp'},
      {value: 3, label: 'SofChef'},
      {value: 4, label: 'CMV'},
    ]
    const [captedFrom, setCaptedFrom] = useState(options[0]);


    // LOADING CONTROLLER
    const [loading, setLoading] = useState(false);


    // ALERTS CONTROLLER
    const [warnAlert, setWarnAlert] = useState({show: false, title: null, text: null});




    // FUNCTIONS ===========================>

    useEffect(() => {
      if(lead){
        setName(lead?.name);  
        setEmail(lead?.email);
        setPhone(lead?.phone);
        setDocument(lead?.document ?? null);

        const cptdf = options.find((opt) => opt.label.toLowerCase() == lead?.capted_from.toLowerCase());
        setCaptedFrom(cptdf);

        setCheckActive(lead?.active);
        setCheckIsValid(lead?.is_valid);
      }
    }, [view, lead])



    // FUNÇÃO QUE SALVA OS DADOS DO CLIENTE
    const handleSaveData = async () => {
      try{
        setLoading(true);

        // Valida os dados do formulário
        if(!name){
          setWarnAlert({show: true, title: 'Alerta', text: 'Insira um nome válido para continuar!'});
          return;
        }

        if(!email){
          setWarnAlert({show: true, title: 'Alerta', text: 'Insira um telefon válido para continuar!'});
          return;
        }

        if(!phone){
          setWarnAlert({show: true, title: 'Alerta', text: 'Insira um telefon válido para continuar!'});
          return;
        }

        // Constrói o path utilizado para salvar os dados na api
        const path = (lead && lead?.id) ? `/leads/update` : `/leads/register`;

        let data = {
          name: name,
          email: email,
          phone: phone,
          document: document,
          captedFrom: captedFrom.label,
          active: checkActive,
          isValid: checkIsValid,
        }

        if(lead && lead?.id){
          data.id = lead?.id;
        }

        const res = await axios.post(path, {
          data: data
        })

        if(res.status == 201){
          onReturn();
        }

      } catch (e) {
        console.error('ERROR - SAVE EDITED DATA FUNCTION:', e);
        setWarnAlert({show: true, title: 'Erro', text: 'Houve um erro ao salvar os dados do cliente. Tente novamente em instantes!'});
      
      } finally {
        setLoading(false);
      }
    }



    const handleChangeDropdownSelector = (value) => {
      setCaptedFrom(options[value]);
    }
    



    // COMPONENT ===================================================>

    return view && (
      <div id={styles.editInformationsArea}>
        
        <div className={styles.editInformationsOverflow} />

        <div className={styles.editBox}>

          {/* BOX HEADER */}
          <div className={styles.editBoxHeader}>

            <div className={styles.boxHeaderContainer}>
              <h1 className={styles.titleBox}>{lead ? lead?.name : 'Registrar lead'}</h1>

              <button className={styles.closeBtn} onClick={() => onClose()}>
                <IoIosCloseCircle size={30} color='#fff'/>
              </button>

            </div>
          </div>



          {/* BOX CONTAINER AREA */}

          <div id={styles.boxContainer}>

            <div className={styles.form}>

              <div className={styles.formArea}>

                <p className={styles.titleInformations} style={{marginBottom: 0}}>Dados do lead:</p>

                <div className={styles.rowInputsArea}> 
                  <div className={styles.inputAreaConfig}>
                    <label htmlFor='payment-price' className={styles.labelInput}>Nome: *</label>
                    <input className={styles.inputConfig} name="payment-price" type="text" value={name} onChange={(event) => setName(event.target.value)} placeholder={lead?.name ?? 'Nome'}/>
                  </div>

                  <div className={styles.inputAreaConfig}>
                    <label htmlFor='payment-price' className={styles.labelInput}>Email: *</label>
                    <input className={styles.inputConfig} name="payment-price" type="text" value={email} onChange={(event) => setEmail(event.target.value)} placeholder={lead?.email ?? 'Email'}/>
                  </div>

                </div>

                <div className={styles.rowInputsArea}> 
                  <div className={styles.inputAreaConfig}>
                    <label htmlFor='payment-price' className={styles.labelInput}>Telefone: *</label>
                    <input className={styles.inputConfig} name="payment-price" type="text" value={phone} onChange={(e) => setPhone(e.target.value)} placeholder={lead?.phone ?? 'Telefone'}/>
                  </div>

                  <div className={styles.inputAreaConfig}>
                    <label htmlFor='payment-price' className={styles.labelInput}>CPF:</label>
                    <input className={styles.inputConfig} name="payment-price" type="text" value={document} onChange={(event) => setDocument(event.target.value)} placeholder={lead?.document ?? 'CPF'}/>
                  </div>
                </div>

                <div className={styles.inputAreaConfig}>
                  <label htmlFor='payment-price' className={styles.labelInput}>Captado de:</label>

                  <select 
                    className={styles.dropdownButton}
                    style={{width: '100%'}} 
                    onChange={({target: {value}}) => handleChangeDropdownSelector(value)} 
                    value={captedFrom.value}
                  >
                    {options.map((item) => (
                      <option className={styles.optionDropdown} key={item.value} value={item.value}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>

              </div>


              <div className={styles.formArea}>

                <div className={styles.checkboxArea}>
                  <p className='labelCheckbox'>Lead válido:</p>
                  <input type='checkbox' className={styles.checkboxConfig} checked={checkIsValid} onChange={() => setCheckIsValid(!checkIsValid)} color="#2eb4f1"/>
                </div>

                <div className={styles.checkboxArea}>
                  <p className='labelCheckbox'>Ativo / convertido:</p>
                  <input type='checkbox' className={styles.checkboxConfig} checked={checkActive} onChange={() => setCheckActive(!checkActive)} color="#2eb4f1"/>
                </div>
              </div>

            </div>

            <div className={styles.editButtonsArea}>
              <button id={styles.saveDataButton} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} onClick={() => handleSaveData()}>
                {loading ? (
                  <Oval 
                    visible={true}
                    height="20"
                    width="20"
                    color="#fff"
                    ariaLabel="oval-loading"
                  />
                ) : (
                  <p id={styles.saveDataBtnText}>Salvar</p>
                )}
              </button>
            </div>

          </div>

        </div>


        <BoxAlert
          show={warnAlert.show}
          title={warnAlert.title}
          text={warnAlert.text}
          confirmFunction={() => setWarnAlert({show: false, title: null, text: null})}
        />

      </div>

    )
}